var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bottom" }, [
    _c("div", [
      _c("div", { class: [_vm.langShow ? "" : "bottomContEn", "bottomCont"] }, [
        _vm._m(0),
        _c("div", [_vm._v(_vm._s(_vm.$i18.language("外贸资讯宝GT6.0")))]),
      ]),
      _c("p", [
        _vm._v(" " + _vm._s(_vm.$i18.language("© 特易资讯 版权所有")) + " "),
        _c("span", { staticClass: "go-home" }, [
          _c(
            "a",
            {
              attrs: {
                href: _vm.langShow
                  ? "https://et.topease.net/e_policy.html"
                  : "https://et.topease.net/e_policyEn.html",
              },
            },
            [_vm._v(_vm._s(_vm.$i18.language("用户协议")))]
          ),
        ]),
        _c("span", { staticClass: "go-home" }, [
          _c(
            "a",
            {
              attrs: {
                href: _vm.langShow
                  ? "https://et.topease.net/policy.html"
                  : "https://et.topease.net/policyEn.html",
              },
            },
            [_vm._v(_vm._s(_vm.$i18.language("隐私条款")))]
          ),
        ]),
      ]),
      _vm.langShow
        ? _c("p", [
            _vm._v("备案号：沪ICP备09080027号 "),
            _c("span", [_vm._v("沪公网安备 31010402007884号")]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("../../assets/logo_footer.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }